import { computed } from "mobx";
import { useMemo } from "react";
import { useFilterSettingsStore, useLeaseCompStore } from "..";
import ILeaseComp, { LeaseCompPropertyType } from "../interfaces/ILeaseComp";
import { getMinMax } from "../utils/utils";

export default function (leaseComps: ILeaseComp[]): ILeaseComp[] {
    const { filters: { leaseCompSettings: leaseCompFilters } } = useFilterSettingsStore();

    const numberFilteredLeaseComps = useMemo(() => {
        return leaseComps.filter(lc =>
            (!leaseCompFilters.minTenantLandSize || lc.tenantLandSize && lc.tenantLandSize >= leaseCompFilters.minTenantLandSize) &&
            (!leaseCompFilters.maxTenantLandSize || lc.tenantLandSize && lc.tenantLandSize <= leaseCompFilters.maxTenantLandSize) &&
            (!leaseCompFilters.minBuildingSize || lc.buildingSize && lc.buildingSize >= leaseCompFilters.minBuildingSize) &&
            (!leaseCompFilters.maxBuildingSize || lc.buildingSize && lc.buildingSize <= leaseCompFilters.maxBuildingSize) &&
            (!leaseCompFilters.minAnnualRent || lc.totalRent && lc.totalRent >= leaseCompFilters.minAnnualRent) &&
            (!leaseCompFilters.maxAnnualRent || lc.totalRent && lc.totalRent <= leaseCompFilters.maxAnnualRent) &&
            (!leaseCompFilters.minLeaseExpiration || lc.leaseExpiration && lc.leaseExpiration >= leaseCompFilters.minLeaseExpiration) &&
            (!leaseCompFilters.maxLeaseExpiration || lc.leaseExpiration && lc.leaseExpiration <= leaseCompFilters.maxLeaseExpiration) &&
            (!leaseCompFilters.minDateModified || lc.modifiedDate && lc.modifiedDate >= leaseCompFilters.minDateModified) &&
            (!leaseCompFilters.maxDateModified || lc.modifiedDate && lc.modifiedDate <= leaseCompFilters.maxDateModified)
        );
    }, [
        leaseComps,
        leaseCompFilters.minTenantLandSize, leaseCompFilters.maxTenantLandSize,
        leaseCompFilters.minBuildingSize, leaseCompFilters.maxBuildingSize,
        leaseCompFilters.minAnnualRent, leaseCompFilters.maxAnnualRent,
        leaseCompFilters.minLeaseExpiration, leaseCompFilters.maxLeaseExpiration,
        leaseCompFilters.minDateModified, leaseCompFilters.maxDateModified,
    ]);

    return useMemo(() => {
        if (!leaseCompFilters.propertyTypes.length)
            return numberFilteredLeaseComps;

        return numberFilteredLeaseComps.filter(l => leaseCompFilters.propertyTypes.includes(l.propertyType as LeaseCompPropertyType));
    }, [numberFilteredLeaseComps, leaseCompFilters.propertyTypes]);
}

export const useMinMaxTenantLandSize = () => {
    const leaseCompStore = useLeaseCompStore();
    return useMemo(() => computed(() => getMinMax(leaseCompStore.leaseComps, leaseComp => leaseComp.tenantLandSize)), []).get();
}

export const useMinMaxBuildingSize = () => {
    const leaseCompStore = useLeaseCompStore();
    return useMemo(() => computed(() => getMinMax(leaseCompStore.leaseComps, leaseComp => leaseComp.buildingSize)), []).get();
}

export const useMinMaxAnnualRent = () => {
    const leaseCompStore = useLeaseCompStore();
    return useMemo(() => computed(() => getMinMax(leaseCompStore.leaseComps, leaseComp => leaseComp.totalRent)), []).get();
}